import { lazy, Suspense, useState } from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import SkipToContent from './components/SkipToContent';
import AnimatedBackground from './components/AnimatedBackground';
import Navigation from './components/Navigation';

// Lazy load components for better performance
const Hero = lazy(() => import('./components/Hero'));
const About = lazy(() => import('./components/About'));
const Experience = lazy(() => import('./components/Experience'));
const Projects = lazy(() => import('./components/Projects'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const ScrollToTop = lazy(() => import('./components/ScrollToTop'));

import { ThemeProvider } from './context/ThemeContext';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <div className="relative min-h-screen bg-white dark:bg-slate-900 text-slate-900 dark:text-white transition-colors duration-300">
          <SkipToContent />
          <AnimatedBackground isMobileMenuOpen={isMobileMenuOpen} />
          <Navigation isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
          <Suspense fallback={<LoadingSpinner />}>
            <main id="main-content" role="main">
              <Hero />
              <About />
              <Experience />
              <Projects />
              <Contact />
            </main>
            <Footer />
            <ScrollToTop />
          </Suspense>
        </div>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
